var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterCrops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eSXi1Nsp3Fx1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4207.16 2293.38",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3814,1740.26c-4.2,141.57-19.52,276.64-54.78,399.13l-1252.19,3c-35.25-122.49-54.78-260.42-54.78-402.13c0-560,304.84-1013.93,680.87-1013.93s698.16,429.9,680.88,1013.93Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2145.5c63.49-62.6,160.78-20.9,160.78-20.9s-28.91-128.86,96.59-167.6c143.89-44.45,201.44,65.68,201.44,65.68s35.35-211.31,222.92-191.55c299.8,31.59,119.76,335.94,449.23,239c157.81-46.43,182.89,74.4,182.89,74.4Z",
    fill: "#dbe5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4207.16,2141.4l-1621.94,1c64.24-62.6,162.68-20.89,162.68-20.89s-29.25-128.87,97.74-167.64c47.49-14.49,85.68-12.54,115.59-3.34c46.070715,14.107873,95.999573-2.856014,123.94-42.11c30.34-42.27,86.38-80.41,189.86-80.41c88.32,0,156.56,48.65,232.06,96.5c21.11-27,57-44.7,97.65-44.7c65,0,117.62,45.22,117.62,101c.000653,10.855446-2.009945,21.617062-5.93,31.74c59.46,8.45,128.34,3.86,211.65-22.82c232.21-74.42,279.08,151.67,279.08,151.67Z",
    fill: "#dbe5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.39,2272.89c0,11.32-51.68,20.49-115.43,20.49s-115.43-9.17-115.43-20.49c0-7.83,24.75-14.64,61.12-18.09l-30.73-54.08l51.3,30.5v-78.34L478,2213.2L529.33,2008L521,2222.9l52.69-32.58L537.93,2255c35.46,3.46,59.46,10.18,59.46,17.89Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3776.31,2018.55l-264.14,2.29c-5.15-.23-10.35-.71-15.59-1.47-133.62-19.31-209.16-62-246.13-132.88-26.270922,17.961219-61.291643,16.214298-85.644699-4.272171s-32.069399-54.691156-18.870654-83.649054s44.077505-45.57129,75.515353-40.628775c-.61322-22.011059-.115922-44.03904,1.49-66c12.75-185.35,107-319.26,251.89-324.09s266.76,120.89,273,306.57c.48,14.49.23,28.94-.7,43.26c6.334795-.943597,12.718718-1.521222,19.12-1.73c87.54-2.93,171.21,62.45,174,146s-76.4,153.67-163.94,156.6Z",
    fill: "#ffdb00"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3484.25,
    y1: 1534.18,
    x2: 3484.25,
    y2: 2140.44,
    fill: "none",
    stroke: "#b59b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3423.94,1504v99.51c-.002653,12.069083,4.789913,23.644755,13.323105,32.179823s20.107812,13.330177,32.176895,13.330177v0c8.179337,0,14.81,6.630663,14.81,14.81",
    fill: "none",
    stroke: "#b59b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3484.25,1605.89c-.001135-20.438832,8.270198-40.007947,22.93-54.25l25.6-24.86",
    fill: "none",
    stroke: "#b59b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3579.46,1765.72l-42.91,34c-33.033952,26.141196-52.299376,65.95395-52.3,108.08",
    fill: "none",
    stroke: "#b59b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3484.25,2120.17c0-32.032515,25.967485-58,58-58h83.8c53.186639,0,96.304478-43.113361,96.31-96.3v-97.54",
    fill: "none",
    stroke: "#b59b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3782.81,1894.67v16.52c.000001,14.101448-11.428553,25.534479-25.53,25.54h-9.38c-6.770977,0-13.264632,2.68976-18.052436,7.477564s-7.477564,11.281459-7.477564,18.052436",
    fill: "none",
    stroke: "#b59b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3722.37,1879.76c0,0-37.77-28.77-20.78-78c0,.01,37.74,28.78,20.78,78Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3780.73,1902c0,0-16.86-65.21,34.89-58.24Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3793.79,1911.31c0,0,24.61-25.42,55.81,0c0,0-18.72,18.37-55.81,0Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3547.73,1790.83c0,0,12.76-45.56,55.58-43.48c0,0-5.97,39.81-55.58,43.48Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3454.09,1911.07c0,0-46.79-17.79-39.51-63.2c0,0,35.01,4.39,39.51,63.2Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3457.62,2069.55c0,0-50.06.34-59.7-44.63c0,0,34.23-8.57,59.7,44.63Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3507.18,1551.64c0,0,2.37-40.69,48.13-47.63c0-.01,3.92,32.86-48.13,47.63Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3423.94,1548.73c0,0-8.09-67.25,3.46-86.31c0,0,34.66,29.81-3.46,86.31Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3399.32,1551.64c0,0-40.55-.48-41.24-47.63c0-.01,29.11,7.21,41.24,47.63Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3646.36,2233.48c0,0-62,11.26-76.86-62.82c0,0,68,6.09,76.86,62.82Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3715.1,2172.73c0,0-30.53,33.38-76.16-3.29c0,0,42.69-25.88,76.16,3.29Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.5,1616.09c-.018825,65.210936-49.687516,119.682788-114.619871,125.704071s-123.770505-38.388552-135.780129-102.484071c-21.864317,8.982716-45.272372,13.609297-68.91,13.62-120,0-217.19-118.65-217.19-265s97.23-265,217.19-265s217.18,118.65,217.18,265c.085121,34.711081-5.560791,69.198104-16.71,102.07c66.75477,3.924801,118.870532,59.219959,118.84,126.09Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 91.58,
    ry: 86.07,
    transform: "translate(171.88 1820.19)",
    fill: "#ffdb00"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 28.81,
    transform: "translate(485.44 1446.94)",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.16,
    y1: 1286.05,
    x2: 217.16,
    y2: 2143.05,
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.84,1256.93v99.51c-.010614,12.077851,4.779171,23.664804,13.314815,32.209825s20.11733,13.347526,32.195185,13.350175v0c8.175433-.000002,14.80448,6.624568,14.81,14.8",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.47,1813.76v99.51c-.002656,12.074282,4.794026,23.654504,13.333709,32.190436s20.122011,13.327525,32.196291,13.319564",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.16,1358.81c-.001135-20.438832,8.270198-40.007947,22.93-54.25l25.59-24.87",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.36,1518.64l-42.9,33.94c-33.035519,26.144323-52.300953,65.96078-52.3,108.09",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.16,1873.09c0-32.032515,25.967485-58,58-58h10.67c25.541161.002653,50.036984-10.142359,68.097312-28.202688s28.205341-42.556151,28.202688-68.097312v-97.53",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,1647.58v16.53c0,6.770977-2.68976,13.264632-7.477564,18.052436s-11.281459,7.477564-18.052436,7.477564h-9.38c-14.105353,0-25.54,11.434647-25.54,25.54",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,1632.68c0,0-37.76-28.77-20.78-78c0,.01,37.75,28.78,20.78,78Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.5,1654.86c0,0-16.86-65.21,34.9-58.23Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.57,1664.22c0,0,24.61-25.42,55.81,0c0,0-18.72,18.37-55.81,0Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63,1543.74c0,0,12.77-45.55,55.58-43.47c0,0-5.96,39.81-55.58,43.47Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.47,1700.68c0,0-49.38,8.28-66-34.59-.03,0,32.41-13.89,66,34.59Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,1866.1c0,0-37.37-4.83-40-39.34.02,0,26.42-2.92,40,39.34Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.58,1774.81c0,0-36.28,34.49-74.07,8.29c0,0,19.1-29.67,74.07-8.29Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71,1495.25c0,0-50.06.34-59.7-44.63-.01,0,34.23-8.57,59.7,44.63Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09,1304.56c0,0,2.37-40.7,48.13-47.63c0,0,3.92,32.86-48.13,47.63Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.84,1301.65c0,0-8.09-67.25,3.47-86.32c0,0,34.69,29.81-3.47,86.32Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,1304.56c0,0-40.56-.49-41.25-47.63.02,0,29.12,7.21,41.25,47.63Z",
    fill: "#423c52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1434.91,2145.5c0-.37,0-.73,0-1.09c0-29.65,23.73-53.67,53-53.67c10.660635-.014908,21.070353,3.233985,29.83,9.31c2.2-46.25,36.49-83,78.49-83c15.825201.053834,31.200405,5.271362,43.79,14.86c7.42-50.87,53.49-90,109.18-90c60.88,0,110.25,46.8,110.25,104.51-.003215,4.572702-.317272,9.139898-.94,13.67c3.694107-.623177,7.433699-.937597,11.18-.94c28.7,0,53.55,18.43,65.55,45.27l-1.39.37h55c6.68-42.14,39.65-74.15,79.34-74.15c35.73,0,66,25.94,76.59,61.88c11.28715-6.632532,24.138398-10.136162,37.23-10.15c20.41,0,39,8.46,53.23,22.42c10.161612,10.098643,17.795354,22.453792,22.28,36.06v4.68Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 32.75,
    transform: "translate(2043.93 2196.67)",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13.06,
    transform: "translate(2110.93 2175.64)",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13.06,
    transform: "translate(2037.5 2100.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 8.68,
    transform: "translate(1485.36 2122.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17.86,
    transform: "translate(1693.3 2017.72)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M777.51,305.05c0,.54,0,1.08,0,1.63h1051.92c-.24-33.95-29.31-61.35-65.09-61.35h-103.24l2.46-.55c-21.25-40.43-65.25-68.19-116.09-68.19-6.621723.001059-13.235015.472244-19.79,1.41c1.104362-6.80438,1.659486-13.686583,1.66-20.58C1529.34,70.49,1441.91,0,1334.09,0c-98.63,0-180.21,59-193.37,135.59-23.186142-14.694954-50.089474-22.456465-77.54-22.37-74.37,0-135.12,55.33-139,125-16.05268-9.288059-34.29433-14.121198-52.84-14-51.81-.02-93.83,36.16-93.83,80.83Z",
    fill: "#e5f1ef"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1878.46,
    y1: 2142.16,
    x2: 1878.46,
    y2: 488.26,
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1981.3,607.78l-90.4,220.59c-8.212761,20.055051-12.438194,41.518486-12.44,63.19v36.7",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1939.45,
    y1: 709.89,
    x2: 2003.2,
    y2: 679.38,
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.89,587.17l31.37,67.6c5.401664,11.643461,8.199972,24.324574,8.2,37.16v36",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.38,791l112.33,235c12.341952,25.822462,18.748514,54.079669,18.75,82.7v57.32",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.41,1158.08l-170.31,265c-16.73776,25.877858-25.641522,56.040912-25.64,86.86v51.92",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970.22,634.81c0,0-19.48-67.51,54-94.78.01-.03,19.09,66.61-54,94.78Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.64,898.22c0,0-50.84,1.85-65.17-52.69c0,0,54.09-6.47,65.17,52.69Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,1232.83c0,0,27.26-44.67,97.51-27.65c0,0-33.69,51.22-97.51,27.65Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.14,645.2c0,0-36.63,30-73.41-13.26c0,0,46.9-20.79,73.41,13.26Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.46,830c0,0-37.64-40.69-.66-103.71c0,.04,45.29,41.14.66,103.71Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1962.13,1336.69c0,0,22-54.33,108.39-48.39c0,0-30.68,60.26-108.39,48.39Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.73,505.37c0,17.35-11.72,31.43-26.16,31.43s-26.16-14.08-26.16-31.43s26.16-86.8,26.16-86.8s26.16,69.43,26.16,86.8Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.64,621.11c0,0-60.58-17.3-41.17-90.32c0,0,58.3,35.52,41.17,90.32Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.63,828.13c0,0-52.4-23.27-49.63-96.3c0,0,59.34,20.02,49.63,96.3Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1829.19,903.3c0,0-34.66-39.28-7.86-92.9c0,0,36.05,45.76,7.86,92.9Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.44,1273.72c0,0-37.35-70.47,25-119.46.05,0,30.37,65.6-25,119.46Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2047.55,1201.31c0,0-7.61-78,54.32-103c0,.03,17.07,65.93-54.32,103Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1962.13,1336.69c0,0,41.41-39.82,126.69-10.85c0,0-51.82,43.16-126.69,10.85Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980.14,690.41c0,0,13.12-50.09,75.51-35.76c0,0-19.3,48.42-75.51,35.76Z",
    fill: "#b59b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1970.45,633.36c0,0,13.11-50.09,75.51-35.76.04,0-19.3,48.4-75.51,35.76Z",
    fill: "#b59b00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2483.17,1129.28c17.32,66-48.07,61.73-31.07,113s117.07,24.89,117.07,24.89l-3.74-137.84Z",
    transform: "translate(.000001 0)",
    fill: "#ffdb00"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2553.73,1216.48 2554.03,1264.77 2660.31,1264.77 2632.18,1186.17 2553.73,1216.48",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2632.95,1188.32 2554.03,1264.78 2553.77,1216.46 2632.18,1186.17 2632.95,1188.32",
    fill: "#423c52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2483.17,1129.28c-5.74-8.17-11.1-39.29,34.66-59.62s71.64-27.74,118.32,7.39s107.22,65.63,108.15,132.18-60,85.5-115.45,78.57-58.71-72.3-23.26-91l-33.34-59.15c0,0-68.25,21.21-89.08-8.37Z",
    fill: "#ffdb00"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 20.89,
    transform: "translate(2786.62 1228.31)",
    fill: "#ffdb00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2483.53,1129.78c34.54,23.81,77.28,11,77.28,11l24.33-6.79c16.975695-4.776544,34.719559,4.573463,40.376843,21.276299s-2.752526,34.911144-19.136843,41.433701l-53.63,20.78c-10.858284,4.205819-22.997644,3.561845-33.350015-1.769167s-17.927176-14.83896-20.809985-26.120833l-2.22-8.66-8,1.71c-1.722349.369665-3.518621-.083674-4.859283-1.226373s-2.07285-2.844466-1.980717-4.603627Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.36,
    ry: 7.61,
    transform: "matrix(.941235-.337752 0.337752 0.941235 2511.457266 1163.704439)",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2600.63,1144.07c-10.34,2.52-16.55,13.43-13.89,24.39",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2401,1641.35c-22.58,23.91-46.95,49.71-72,76.13-28.57,30.15-58,61.11-86.48,91-93.08,97.62-176.64,183.92-190.45,193.84-33.27,23.91-88.39,59.3-191.33,59.26-26.34,0-73.33-48.41-97.33-75.2-2.604021-2.963727-3.22215-7.181473-1.578066-10.767779s5.243054-5.870791,9.188066-5.832221c37,.66,87.89-3.64,100-21.56c21.84-32.23-50.86-14.54-48.78-45.76c0,0,93.58-14.54,123.74-40.9c12.09-10.56,159.78-198.38,286.25-360.1v0c0,0,8.41,74.54,168.77,139.89Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1919.93,2030.83c-26.92,7.79-56.44,13-96,13",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899,2008.89c-26.92,7.79-58.43,13-98,13",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1878.14,1987c-26.92,7.79-59.44,13-99,13",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2239.38,1807.45c-8.088202-11.451724-12.405139-25.140087-12.35-39.16c0-36,27.56-65.16,61.57-65.16c13.579121.021153,26.736759,4.717787,37.26,13.3",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3107.46,1698.86v.16c0,122.58-477.21-14.37-477.21-14.37s474-80.78,477.2,13.35c0,.28.01.58.01.86Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3104.43,1695.77c-3.2-89.52-473.14-12.7-473.14-12.7l-89.07-143.65c-4.300135-6.918306-11.57146-11.445083-19.67738-12.25019s-16.125625,2.202914-21.70262,8.14019c-22,23.41-57.78,61.46-99.86,106-160.34-65.33-168.72-139.89-168.72-139.89c44.44-56.83,86.26-110.44,118.64-152c40.485416-51.956209,102.672583-82.33398,168.54-82.33h227.56c62.461675-.013404,121.02598,30.35797,157,81.42c75.78,107.62,199.24,290.22,200.43,347.26Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3028.82,1659.86c0,0,12,25.28,23.67,70.35c16.17,62.45,25.77,147.28-24.67,184.07-83,60.5-433.27,38.82-433.27,38.82v191.34h-196.11c-79.275603-.001233-148.187451-54.413047-166.576437-131.526382s18.552509-156.767678,89.296437-192.543618c104.26-52.73,265-128.6,311.13-135.3Z",
    fill: "#fe552f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2947,1689.5c30.36,99.79,32.79,214.87-24.66,256.56",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3045.88,1706.67c-93.6-28.3-372-28.71-413.54-21.51c260.31-45.15,396.8-26.56,396.8-26.56s13.26,22.14,16.74,48.07Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2438.47,
    y1: 1948.04,
    x2: 2584.62,
    y2: 1948.04,
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2888.2,1848.73 2826.41,1890.52 2764.63,1848.73 2764.63,1757.08 2888.2,1757.08 2888.2,1848.73",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3053.75,1878.38 3015.01,1848.73 3015.01,1757.08 3055.83,1757.08",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3157,2186.6l-80-40.67c-10.073485-3.306541-20.607723-4.994179-31.21-5h-323.27c-.186533.009982-.373467.009982-.56,0-20.56-.74-37.12-43.33-37.12-95.75c0-52.89,16.86-95.77,37.68-95.77.66921-.002823,1.337709.043972,2,.14l334.35-8.13l155.25,246.78c0,0-31.51,11.74-57.12-1.6Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3182.17,2033.18c43.51,62.58,60.92,135.27,41.87,148.68-23.81,16.74-90.33-23.56-135.19-89.26s-73.78-139.52-23.71-151.18c28.34-6.6,68.09,21.36,117.03,91.76Z",
    fill: "#fff",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3041.7,
    y1: 1995.42,
    x2: 3153.46,
    y2: 1995.42,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3038.59,
    y1: 1970.35,
    x2: 3129.91,
    y2: 1970.35,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3047.96,
    y1: 2017.71,
    x2: 3171.06,
    y2: 2017.71,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3057.74,
    y1: 2039.99,
    x2: 3186.78,
    y2: 2039.99,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3070.16,
    y1: 2062.28,
    x2: 3200.22,
    y2: 2062.28,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3085.22,
    y1: 2084.57,
    x2: 3211.43,
    y2: 2084.57,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3099.86,2106.86 3217.32,2106.86 3220.54,2106.86",
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3118.08,
    y1: 2129.14,
    x2: 3227.39,
    y2: 2129.14,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3142.11,
    y1: 2151.43,
    x2: 3230.29,
    y2: 2151.43,
    fill: "none",
    stroke: "#907b00",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3021.88,2193l-104.71-43.61c-10.076912-3.306597-20.614449-4.994223-31.22-5h-323.23c-.183194.010091-.366806.010091-.55,0-20.56-.74-37.12-43.32-37.12-95.75c0-50.3,20-99.11,39.83-103.76h334.19l159.65,242c4.17,7.12-22.36,12.83-36.84,6.12Z",
    fill: "#8c7200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585.34,2144.44h-9.73c-16.23-14.08-28-53.45-28-99.24c0-45.18,13-85.91,30-100.29h9.91c-16.81,5-34.87,47-34.87,100.29-.03,54.6,16.65,94.25,32.69,99.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3019.24,2038.76c43.51,62.59,60.92,135.27,41.87,148.68-23.81,16.75-90.33-23.55-135.19-89.26s-73.78-139.52-23.71-151.18c28.34-6.6,68.09,21.37,117.03,91.76Z",
    fill: "#fff",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3003.36,2185.32l-28.68-11.94c-27.02576-18.808867-50.440068-42.334962-69.12-69.45-37.21-54.51-54.17-111.33-42.19-141.39c2.723935-7.248212,7.705624-13.428872,14.21-17.63h12.42c-10.58,2.91-17.95,9.47-21.94,19.48-11.39,28.58,5.36,83.52,41.67,136.72c26.44,38.79,63.17,68.82,93.63,84.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2877.66,
    y1: 1966.53,
    x2: 2956.64,
    y2: 1966.53,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2875.66,
    y1: 1988.81,
    x2: 2979.76,
    y2: 1988.81,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2879.84,
    y1: 2011.1,
    x2: 2997.19,
    y2: 2011.1,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2888.2,
    y1: 2033.39,
    x2: 3015.96,
    y2: 2033.39,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2899.69,
    y1: 2055.67,
    x2: 3030.86,
    y2: 2055.67,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2912.23,
    y1: 2077.96,
    x2: 3042.44,
    y2: 2077.96,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2927.9,
    y1: 2100.25,
    x2: 3052.89,
    y2: 2100.25,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2943.57,
    y1: 2122.54,
    x2: 3059.97,
    y2: 2122.54,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2963.42,
    y1: 2144.82,
    x2: 3066.61,
    y2: 2144.82,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2990.58,
    y1: 2167.11,
    x2: 3068.77,
    y2: 2167.11,
    fill: "none",
    stroke: "#8c7200",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1187.23,2196h-223.93c0,0-57-16.73-52-101.59c1.69-28.44,7.79-61.6,16.78-103l.22-3.12c66.9,2.81,138.73.53,205.89-12.11-11.25,58.1-16.62,103.43-11.44,125.54c10.4,44.41,64.48,94.28,64.48,94.28Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.1,1976.77L1121.28,2065c0,0-136.36-10.46-197.61-52.38l4.41-24.35h.6c66.94,2.81,138.74.73,205.42-11.5Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.45,2205c.000037,2.382376-.949767,4.666454-2.639047,6.346349s-3.978614,2.61696-6.360953,2.603651h-222.45c4.942949,0,8.95-4.007051,8.95-8.95s-4.007051-8.95-8.95-8.95h222.5c4.931587.027322,8.922678,4.018413,8.95,8.95Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M963.3,2196h-240.72c-9.606097-.004601-18.671689-4.445237-24.563712-12.032146s-7.950032-17.469661-5.576288-26.777854l45.83-189.65c48.85,8.39,116.45,17.64,190,20.74l-.22,3.12c-9,41.41-15.09,74.57-16.78,103-4.99,84.88,52.03,101.6,52.03,101.6Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.08,1988.27L914.2,2065c0,0-107.66-20.18-179.6-82.24l3.67-15.21c48.2,8.28,115.51,17.39,188.77,20.61Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.93,2205c0,4.942949-4.007051,8.95-8.95,8.95h-263.51c-3.423418.362372-6.753635-1.259855-8.578624-4.178848s-1.824988-6.623311,0-9.542304s5.155206-4.54122,8.578624-4.178848h263.53c4.923775.038222,8.902793,4.026152,8.93,8.95Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1221.89,1031.16l-79.36-252.41c22.51,3.69,94.32,13.63,170.18,205.43c14.4,36.43,156.41,364.53,156.41,364.53s11.74,64.55-46.45,63c-31.24-.91-179.17-270.33-200.78-380.55Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1268.34,1389.74c-12.27,120.82-97.13,411.47-131,586.44-141,26.54-305.78,7.38-399-8.63-46.91-8.06-76.53-15.32-77.55-15.57v0c6.58-192.49,125.07-330.37,168.47-636.41c24.2-170.66,22-351.86,21.32-469.14-.101121-19.691778,7.650621-38.611737,21.539288-52.571724s32.768675-21.808536,52.460712-21.808276h183.1c40.086482.016014,75.800064,25.324157,89.1,63.14c32.99,93.81,98.6,288.34,71.56,554.55Z",
    fill: "#ffdb00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.65,1357.51c-14.45,136.41-128.29,436.17-156.91,639",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1387.85,1422.8l-204.55-59c-19.12998-5.512246-34.888007-19.122895-43.124242-37.247613s-8.125062-38.94665.304242-56.982387l121.89-260.89l245.43,71.34-33.55,285.75c-2.45447,19.761194-13.437688,37.457144-30.056769,48.426892s-37.207786,14.113459-56.343231,8.603108Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.8,1080.07c-7.8,27.07-67.44,33-135.79,13.35s-117.44-57.62-109.64-84.69s69.54-33,137.89-13.34s115.35,57.61,107.54,84.68Z",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41.22,
    ry: 115.44,
    transform: "matrix(.276979-.960876 0.960876 0.276979 1384.534828 1044.093579)",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1623.13,1144.34 1614.87,1172.96 1578.61,1224.19 1472.79,1373.7 1489.39,1244.4 1572.32,1182.34 1623.13,1144.34",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.13,1144.34l-8.26,28.62-36.26,51.23c-5.92-11.87-8.43-26.53-6.29-41.85Z",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 62.88,
    ry: 50.9,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1634.322699 1165.379983)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1640.312283 1135.34312)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1630.915853 1194.890507)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1636.137791 1165.646906)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1660.168903 1153.105586)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1655.984411 1183.399373)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1615.243623 1146.835678)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.15,
    ry: 4.98,
    transform: "matrix(.142456-.989801 0.989801 0.142456 1611.059233 1177.12804)",
    fill: "#fff",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.33,1009.78l-49.39-15.58c-58.47-16.85-114.35,33.44-103.73,93.36l32.27,182.06Z",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDashoffset: 500
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.12,1153c17.687288,0,34.65015,7.026248,47.156951,19.533049s19.533049,29.469663,19.533049,47.156951v706.15",
    fill: "none",
    stroke: "#dbe5e5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDashoffset: 500,
    strokeDasharray: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.17,1135.27h49.72c20.89722-.002653,40.939307,8.297561,55.715873,23.074127s23.07678,34.818653,23.074127,55.715873v718.94",
    fill: "none",
    stroke: "#dbe5e5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDashoffset: 500,
    strokeDasharray: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657,1183.32c12.11,1.2,20.72,22.54,20.72,59.37l1,707.2",
    fill: "none",
    stroke: "#dbe5e5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDashoffset: 500,
    strokeDasharray: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1630.7,
    y1: 1194.64,
    x2: 1630.7,
    y2: 2010.79,
    fill: "none",
    stroke: "#dbe5e5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDashoffset: 1000,
    strokeDasharray: 15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1523.81,1243.46c0,0,20.45,38.82,17,67.25s-46.3,78.68-93,101c0,0,28.53-17.41,11.89-77-8.45-30.29,64.11-91.25,64.11-91.25Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.36,1268.53c0,0,15.23,43,11.76,71.43",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.6,1290.47c0,0,15.23,43,11.76,71.43",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.75,1310.32c0,0,15.23,43,11.76,71.43",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1250.91,1480.85c-36.9-12.76-152.32-91.73-252.12-230.76-24.494368-34.090203-46.869902-69.653942-67-106.49-42.43-77.71-77.34-166.64-95.27-264.74-8.24-45.07,7.71-71.93,29.24-87.42c43.09-31,104-11.44,122.45,38.3c46.75,126,168.05,421,305.81,503.5c28,16.75-52.8,12.77-58.23,19.31-10.18,12.23,26.62,33.59,123,58.74c22.28,5.81-87.24,76.71-107.88,69.56Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.28,1403.86c20.39,8.85,44.48,17.77,89,26.24",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.43,1420.57c20.39,8.86,43.43,16.73,87.91,25.2",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.44,1438.33c20.4,8.86,34,17.78,78.52,26.24",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.89,1142.56c3.154037-1.959705,6.540169-3.5184,10.08-4.64c27.93-8.83,59.22,11.38,69.9,45.14c8,25.25,2.18,50.94-13,66",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1101,772.13c.039637,1.216165-.050878,2.433082-.27,3.63-1.36,8.28-9.14,27.83-52.07,27.22-54.42-.76-51.5-30.85-51.5-30.85l31.71-63h85.13Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101,772.13l13-63h-65c0,0-.12,48.1,52,63Z",
    fill: "#423c52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1144.13,626.41c-4.55-12.9-17-15.89-17.47-16.06.19.4,4.69,10.2-15.29,31.87-20.4,22.13-62.3,12.26-62.3,12.26h-22.57c-10.954135.016132-20.735441,6.863046-24.5,17.15v0c-1.058479,2.882254-1.596833,5.929541-1.59,9v1.18c0,.06,0,.13,0,.19-6.5,23.38-31.38,45.19-64.82,53.92-44,11.5-86.12-4-94.1-34.52s21.18-64.66,65.17-76.16c33.29-8.7,65.53-2,82.69,15.09-2.25-42,23.7-76.11,68-75.42c73.83,1.14,89.46,69.09,86.78,61.5Z",
    fill: "#fe552f"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 23.51,
    transform: "translate(797.85 709.41)",
    fill: "#fe552f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1118.63,742.43c-36.41,7.86-69.56-33.34-69.56-33.34h-22.57c-14.415594.000017-26.107933-11.674423-26.13-26.09v-2.33c-.002653-6.931839,2.74915-13.580676,7.649763-18.483165s11.548397-7.656836,18.480237-7.656835h22.57c0,0,41.9,9.87,62.3-12.26c20-21.67,15.48-31.47,15.29-31.87c1.815044.530656,3.586871,1.19927,5.3,2c5.39,2.53,9.56,7.71,12.59,14.61c14.93,33.83,2.54,109.28-25.92,115.42Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1042.14,686.91c0-5.155809-2.048137-10.100449-5.693844-13.746156s-8.590347-5.693844-13.746156-5.693844",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.92,659.84c0,0-28.63-1-28.63,47.71",
    fill: "none",
    stroke: "#423c52",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.39,
    ry: 3.66,
    transform: "matrix(.23972-.970842 0.970842 0.23972 1139.862571 683.872072)",
    fill: "#423c52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.92,
    ry: 3.96,
    transform: "matrix(.23972-.970842 0.970842 0.23972 1094.656525 682.441042)",
    fill: "#423c52"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterCrops);
export default __webpack_public_path__ + "static/media/water-crops.d292b2ad575a6ff5ce85c8f95d9ef26b.svg";
export { ForwardRef as ReactComponent };